<template>
  <div class="container">
    <div class="row d-flex align-items-center">
      <div class="col">
        <input type="text" class="form-control" v-model="team.name" />
      </div>
      <div class="col">
        <input type="text" class="form-control" v-model="team.bid_email" />
      </div>
      <div class="col">
        <input type="text" class="form-control" v-model="team.wallet" />
      </div>
      <div class="col">
        <button class="btn btn-primary btn-sm" @click="updateTeam()">
          Update
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from "vue";
import supabase from "@/supabase/config";
const props = defineProps(["team"]);
const emit = defineEmits(["teamUpdated"]);
const team = ref({});
const err = ref("");
onMounted(() => {
  team.value = props.team;
});
const updateTeam = async () => {
  const updateObj = {
    name: team.value.name,
    bid_email: team.value.bid_email,
    wallet: team.value.wallet,
  };
  const { data, error } = await supabase
    .from("teams")
    .update(updateObj)
    .eq("id", props.team.id)
    .select();
  if (error) {
    err.value = error.message;
    setTimeout(() => {
      err.value = "";
    }, 1000);
  } else {
    emit("teamUpdated");
  }
};
</script>
